import { ApiClient } from './api-client';
import { getConfig } from '../../config';

let baseUrl = getConfig().urls['apiUrl'] + '/api';

const apiClient = new ApiClient(baseUrl);

export { apiClient };